// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Qo-z","slideIn":"Ro-z"};